/** @file Renames an image (ASCII name, unique among images). */
import { defineRename } from '../_shared/defineRename';

export const command = defineRename({ domain: 'image', kind: 'image', description: 'Rename an image (ASCII name, unique among images).' });
